export default "__VITE_ASSET__DTWOGjH4__"